import {
  QUICK_DONATE_LOADING,
  QUICK_DONATE_SUCCESS,
  QUICK_DONATE_FAILURE,
} from "redux/types";

const initialState = {
  quickDonateLoading: false,
  quickDonateData: null,
  errors: null,
};

export const quickDonateReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case QUICK_DONATE_LOADING:
      return { ...state, quickDonateLoading: action.payload };
    case QUICK_DONATE_SUCCESS:
      return { ...state, quickDonateData: action.payload };
    case QUICK_DONATE_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
